import { Directive, ElementRef } from '@angular/core';
import { AppState } from '../../config/state';
import { Events, NavController } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';

/**
 * Generated class for the LogoutHeaderDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[logout-header]' // Attribute selector
})
export class LogoutHeaderDirective {
  headerTextTemplate: string = `<span class="headerLogoutText">Logout</span>`
  headerTextElement: any;
  constructor(private state: AppState, private events: Events, private el: ElementRef, private toast : ToastAlertsProvider, private navCtrl : NavController) {
  }

  ngOnInit() {
    if (this.state.patron) {
      this.showLogoutText();
    } else {
      let self = this;
      this.events.subscribe('patronLoggedIn', (status) => {
        if (status) {
          self.showLogoutText();
        } else {
          if (this.headerTextElement !== undefined && this.headerTextElement !== null) {
            this.headerTextElement.parentElement.removeChild(this.headerTextElement);
          }
        }
      });
    }
  }

  showLogoutText() {
    let nativeElement = this.el.nativeElement;
    this.headerTextElement = nativeElement;
    nativeElement.insertAdjacentHTML('afterend', this.headerTextTemplate);
    this.headerTextElement = nativeElement.nextSibling;
    this.headerTextElement.addEventListener('click', () => {
      this.events.publish('patronLoggedIn', false);
      this.state.patron = null;
      this.navCtrl.popToRoot();
      this.toast.triggerToast('You have been logged out!'+ this.state.logoutSummary, '', 'success');
    })
  }

}



// WEBPACK FOOTER //
// ./src/directives/logout-header/logout-header.ts